export const CANARY_COOKIE = 'ecster-cv';
